import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getSocket } from '../services/socket';
import { useAuth } from './AuthContext';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount]     = useState(0);

  const addNotification = useCallback((n) => {
    setNotifications((prev) => [n, ...prev].slice(0, 50));
    setUnreadCount((c) => c + 1);
  }, []);

  useEffect(() => {
    if (!user) return;
    const socket = getSocket();
    if (!socket) return;

    const onOpen = (payload) => {
      console.log('🔔 [Socket] EMAIL OPENED EVENT RECEIVED:', JSON.stringify(payload, null, 2));
      addNotification({
        id: Date.now(),
        type: 'open',
        title: 'Email Opened',
        message: payload.subject,
        meta: `${payload.location?.city || ''} ${payload.location?.country || ''}`.trim() || 'Unknown location',
        timestamp: new Date(),
        payload,
      });
    };

    const onClick = (payload) => {
      console.log('🔔 [Socket] LINK CLICKED EVENT RECEIVED:', JSON.stringify(payload, null, 2));
      addNotification({
        id: Date.now(),
        type: 'click',
        title: 'Link Clicked',
        message: payload.subject,
        meta: payload.originalUrl,
        timestamp: new Date(),
        payload,
      });
    };

    socket.on('email:opened', onOpen);
    socket.on('link:clicked', onClick);

    return () => {
      socket.off('email:opened', onOpen);
      socket.off('link:clicked', onClick);
    };
  }, [user, addNotification]);

  const markAllRead = () => setUnreadCount(0);
  const clearAll    = () => { setNotifications([]); setUnreadCount(0); };

  return (
    <NotificationContext.Provider value={{ notifications, unreadCount, markAllRead, clearAll }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
